import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from "@angular/common/http";
import * as fromInterceptors from '@core/interceptors';
import { importProvidersFrom, Injector, inject, provideAppInitializer } from "@angular/core";
import {
  Router,
  TitleStrategy
} from "@angular/router";
import {TemplatePageTitleStrategy} from '@core/services/set-browser-title.service';
import {MultiLanguageService} from '@app/share/translate';
import {
  appInitializerContinueAsGuestFactory,
  appInitializerLanguageFactory,
} from '@app/core/interceptors/appInitializerFactory';
import {Store} from '@ngrx/store';
import {Actions} from '@ngrx/effects';
import {FacebookPixelService} from "@share/pixel-code/facebook-pixel.service";
import {SnapPixelService} from "@share/pixel-code";
import { RefreshTokenInterceptor } from "@core/interceptors/refresh-token.interceptor";


export const providers = [
  MultiLanguageService,
  provideAppInitializer(() => {
        const initializerFn = (appInitializerContinueAsGuestFactory)(inject(Router), inject(Store), inject(Actions), inject(Injector));
        return initializerFn();
      }),

  // {
  //   provide: APP_INITIALIZER,
  //   useFactory: appInitializerAppSettingsFactory,
  //   deps: [Store, Actions, Injector],
  //   multi: true,
  // },
  provideAppInitializer(() => {
        const initializerFn = (appInitializerLanguageFactory)(inject(MultiLanguageService), inject(Injector));
        return initializerFn();
      }),
  provideAppInitializer(() => {
        const initializerFn = ((ds: FacebookPixelService) => () => ds.initialize())(inject(FacebookPixelService));
        return initializerFn();
      }),
  provideAppInitializer(() => {
        const initializerFn = ((ds: SnapPixelService) => () => ds.initialize())(inject(SnapPixelService));
        return initializerFn();
      }),
  /*{
    provide: HTTP_INTERCEPTORS,
    useClass: ApiHttpInterceptor,
    multi: true,
  },*/
  /*{
    provide: HTTP_INTERCEPTORS,
    useClass: fromInterceptors.HandleErrorsInterceptor,
   multi: true,
  },*/
  {
    provide: HTTP_INTERCEPTORS,
    useClass: RefreshTokenInterceptor,
    multi: true,
  },
  // {
  //   provide: HTTP_INTERCEPTORS,
  //   useClass: fromInterceptors.TimingInterceptor,
  //   multi: true,
  // },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: fromInterceptors.LoadingInterceptor,
    multi: true,
  },
  // {
  //   provide: HTTP_INTERCEPTORS,
  //   useClass: fromInterceptors.TimeoutInterceptor,
  //   multi: true,
  // },
  // { provide: DEFAULT_TIMEOUT, useValue: config.DEFAULT_TIMEOUT },
  { provide: TitleStrategy, useClass: TemplatePageTitleStrategy },
  // { provide: RouteReuseStrategy, useClass: RouteReusableStrategy },
  // CustomPreloadingStrategy,
];
